import { Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";

import RouletteHome from "./RouletteHome";
import RouletteType01 from "./RouletteType01"
import RouletteType02 from "./RouletteType02"
import RouletteType03 from "./RouletteType03"
import RouletteType04 from "./RouletteType04"
import RouletteType05 from "./RouletteType05"

const RouletteMain = () => {
  const location = useLocation();
  return (
    <>
      <AnimatePresence>
        <Routes location={location} key={Location.pathname}>
          <Route element={<RouletteHome />} exact path="/" />
          <Route element={<RouletteHome />} path="/roulettehome" />
          <Route element={<RouletteType01 />} path="/roulettetype01" />
          <Route element={<RouletteType02 />} path="/roulettetype02" />
          <Route element={<RouletteType03 />} path="/roulettetype03" />
          <Route element={<RouletteType04 />} path="/roulettetype04" />
          <Route element={<RouletteType05 />} path="/roulettetype05" />
        </Routes>
      </AnimatePresence>
    </>
  )
}
export default RouletteMain
